export default {
  title: 'Event settings',
  coloredOccupancyTitle: 'Color marking of the occupancy',
  coloredOccupancyDescription:
    'From what percentage should the respective color for the occupancy be displayed?',
  colors: { green: 'Green', yellow: 'Yellow', red: 'Red' },
  period: 'Time period until an expired event is deleted',
  error: {
    loading: 'Event settings could not be loaded',
    update: 'Event settings could not be updated'
  },
  success: { update: 'Event settings were successfully updated' }
};
